export default "__VITE_ASSET__DTcomYNP__"